<script>
import { WS_ROOT } from '../api/config'

export default {
  data () {
    return {
      wsUrl: null,
      wsToken: null,
      wsSubscribeChannels: []
    }
  },
  beforeDestroy () {
    let wsSubscribeChannels = [...this.wsSubscribeChannels]
    for (let channel of wsSubscribeChannels) {
      this.unSubscribeWs(channel)
    }
    this.unConnectWs()
  },
  methods: {
    initWs (url, token, manual = false) {
      this.wsUrl = url || WS_ROOT
      this.wsToken = token || this.$ls.get('userInfo').access_token
      if (!manual) {
        this.connectWs()
        this.subscribeWs()
      }
    },
    connectWs () {
      let url = this.wsUrl + '?access_token=' + this.wsToken
      this.$cable.connection.connect(url)
    },
    subscribeWs (channel = 'ChatChannel', options = {}) {
      this.$cable.subscribe({
        channel: channel,
        ...options
      })
      this.wsSubscribeChannels.push('ChatChannel')
    },
    unConnectWs () {
      this.$cable.connection.disconnect()
    },
    unSubscribeWs (channel = 'ChatChannel') {
      this.wsSubscribeChannels.splice(this.wsSubscribeChannels.indexOf(channel), 1)
      this.$cable.unsubscribe(channel)
    },
    sendWs (content, options = {}, channel = 'ChatChannel') {
      this.$cable.perform({
        channel: channel,
        data: {
          content: content,
          ...options
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/mixins/webSocket.vue